import React, { FC } from 'react'
import { withTheme } from 'emotion-theming'

import { Icon } from 'src/chrome'
import { formatWithLeadingZero } from 'src/helpers'
import { SmallOrLarge } from 'src/app/types'
import { Theme } from 'src/theme/theme'
import { ColorChoices } from 'src/theme/colors'

import styles from './styles'

type FormattedPriceProps = {
  dollars: number | string
  cents: number | string
  color?: ColorChoices
  readonly size?: SmallOrLarge
  theme: Theme
}

const FormattedPrice: FC<FormattedPriceProps> = props => {
  const { dollars, cents, size = 'large', color = 'pink', theme } = props
  return (
    <div css={{ display: 'flex' }}>
      <div css={() => styles.dollarSign(size)}>
        <Icon
          icon={'DOLLARSIGN'}
          size={size === 'large' ? 18 : 12}
          color={theme.colors[color]}
        />
      </div>
      <span css={(theme: Theme) => styles.dollars(size, theme.colors[color])}>
        {dollars}
      </span>
      <span
        css={(theme: Theme) => styles.cents(size, theme.colors[color])}
      >{`.${formatWithLeadingZero(cents)}`}</span>
    </div>
  )
}

export default withTheme(FormattedPrice)
